export default __webpack_public_path__ + "static/media/2311.1731320b.png";